// WhatsApp Business Configuration
// Admin-configurable in the future

export const WHATSAPP_CONFIG = {
  // E.164 format - GoTurkeyTransfer WhatsApp Business Number
  businessNumber: '+905352385797',
  
  // Generate WhatsApp deep link with prefilled message
  generateLink: (bookingData) => {
    const {
      bookingRef,
      pickup,
      date,
      time,
    } = bookingData;

    const message = encodeURIComponent(
      `Hi GoTurkeyTransfer, my booking reference is ${bookingRef}. ` +
      `Pickup: ${pickup}, Date/Time: ${date} ${time}. ` +
      `I need help with ...`
    );

    return `https://wa.me/${WHATSAPP_CONFIG.businessNumber.replace(/\+/g, '')}?text=${message}`;
  },
};

// DataLayer helper functions — DEPRECATED
// All tracking is now centralized in /utils/analytics.js
// Use AnalyticsEvents.purchase(), AnalyticsEvents.whatsAppClick() etc.
// Kept for backward compatibility but should not be used directly
export const DataLayerEvents = {
  pushPurchase: () => {
    console.warn('[GTT Analytics] DataLayerEvents.pushPurchase is deprecated. Use AnalyticsEvents.purchase() from utils/analytics.js');
    return false;
  },
  pushWhatsAppClick: () => {},
  pushReturnTransferClick: () => {},
  pushEmailResend: () => {},
};

// Email resend rate limiter
export const EmailResendLimiter = {
  canResend: (bookingRef) => {
    const key = `vipgez_email_resend_${bookingRef}`;
    const lastResend = localStorage.getItem(key);
    
    if (!lastResend) return true;
    
    // 60 second cooldown
    const cooldown = 60 * 1000;
    return Date.now() - parseInt(lastResend) > cooldown;
  },

  markResent: (bookingRef) => {
    const key = `vipgez_email_resend_${bookingRef}`;
    localStorage.setItem(key, Date.now().toString());
  },

  getCooldownRemaining: (bookingRef) => {
    const key = `vipgez_email_resend_${bookingRef}`;
    const lastResend = localStorage.getItem(key);
    
    if (!lastResend) return 0;
    
    const cooldown = 60 * 1000;
    const remaining = cooldown - (Date.now() - parseInt(lastResend));
    return Math.max(0, Math.ceil(remaining / 1000));
  },
};

// Mask email for privacy
export const maskEmail = (email) => {
  if (!email || !email.includes('@')) return email;
  
  const [localPart, domain] = email.split('@');
  const maskedLocal = localPart.charAt(0) + '***';
  return `${maskedLocal}@${domain}`;
};

// Mask phone for privacy
export const maskPhone = (phone) => {
  if (!phone || phone.length < 6) return phone;
  
  return phone.slice(0, 4) + '****' + phone.slice(-2);
};
